import { Skeleton } from 'antd';

export const SetsSkeleton = () => {
  return (
    <>
      <div className="mb-8">
        <div className="flex items-center gap-4">
          <Skeleton.Avatar active size="large" shape="square" />
          <div>
            <Skeleton.Input active size="large" className="!w-[200px] !mb-2" />
            <Skeleton.Input active size="small" className="!w-[300px]" />
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {[...Array(8)].map((_, index) => (
          <div key={index} className="bg-white rounded-lg shadow-sm p-4 border border-gray-200">
            <div className="flex items-center gap-4">
              <Skeleton.Image active className="!w-16 !h-16" />
              <div className="flex-1">
                <Skeleton.Input active size="small" className="!w-[80%] !mb-2" />
                <Skeleton.Input active size="small" className="!w-[60%]" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}; 